import type { JSX } from "react";
import type { Profil } from "../../types/Users";
import { useTrads } from "../../contexts/trads/useTrads";

export default function ProfilItem({profil}: {profil: Profil}): JSX.Element {
    const {translate}=useTrads();
    
    return (<div>
            <h3>{profil.prenom} {profil.nom}</h3>
            <dl className="row">
            {profil.date_de_naissance && <> <dt className="col-sm-3">{translate('profil_date_naissance')}</dt> <dd className="col-sm-9"> {profil.date_de_naissance}</dd></>}
            {profil.adresse && <> <dt className="col-sm-3">{translate('profil_adresse')} </dt> <dd className="col-sm-9">{profil.adresse}, {profil.code_postal} {profil.commune}</dd></>}
            {profil.tel &&  <> <dt className="col-sm-3">{translate('profil_telephone')}</dt><dd className="col-sm-9"> {profil.tel}</dd></>}
            {profil.mail && <> <dt className="col-sm-3">{translate('profil_email')} </dt><dd className="col-sm-9">{profil.mail}</dd></>}

            {profil.titulaire_iban && <> <dt className="col-sm-3">{translate('profil_titulaire_iban')}</dt><dd className="col-sm-9">{profil.titulaire_iban}</dd></>}
            {profil.iban && <> <dt className="col-sm-3">{translate('profil_iban')}</dt><dd className="col-sm-9">{profil.iban}</dd></>}
            {profil.numero_national && <> <dt className="col-sm-3">{translate('profil_num_national')}</dt><dd className="col-sm-9"> {profil.numero_national}</dd></>}
            </dl>
             {profil.photo && (<img src={profil.photo} alt={translate('profil_photo')} />)}
        </div>
    );
}